import React, { ReactNode } from 'react';
import { ApolloClient, InMemoryCache, ApolloProvider, HttpLink, from } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { useEnvironment } from '../../hooks';
import Cookies from 'universal-cookie';

interface IApolloClientProvider {
  children: ReactNode;
}

export const ApolloClientProvider = (props: IApolloClientProvider) => {
  const { children } = props;
  const { GATEWAY_API_KEY, API_TOKEN, API_GRAPHQL, NODE_ENVIRONMENT } = useEnvironment();
  const cookie = new Cookies();
  const token = cookie.get('User-Token');

  const httpLink = new HttpLink({
    uri: API_GRAPHQL,
    headers: {
      authorization: `Bearer ${API_TOKEN}`,
      'x-api-key': GATEWAY_API_KEY ? GATEWAY_API_KEY : '',
      usertoken: token
    }
  });

  const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (NODE_ENVIRONMENT === 'development') {
      if (graphQLErrors)
        graphQLErrors.forEach(({ message, locations, path }) =>
          console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
        );

      if (networkError) {
        console.log(`[Network error]: ${networkError}`);
      }
    }
  });

  const client = new ApolloClient({
    cache: new InMemoryCache({
      addTypename: false
    }),
    link: from([errorLink, httpLink])
  });

  return <ApolloProvider client={client}> {children} </ApolloProvider>;
};
